import {isPast, parseISO} from 'date-fns'
import {CancellationPenalty} from '../types/offer'

export enum RefundType {
  freeCancellation,
  partialRefund,
  nonRefundable
}

export const hasNoPenalties = (
  cancellationPenalty: CancellationPenalty
): boolean => {
  const {amount, nights, percent} = cancellationPenalty
  return !Number(amount) && !percent && !Number(nights)
}

export const getLastCancellationDeadline = (
  cancellationPenalties: CancellationPenalty[]
) => {
  return cancellationPenalties[cancellationPenalties.length - 1]?.end
}

export const getCancellationDeadline = (
  cancellationPenalties: CancellationPenalty[]
) => {
  const firstPenalty = cancellationPenalties?.[0]
  if (!firstPenalty) return

  return hasNoPenalties(firstPenalty) ? firstPenalty.end : firstPenalty.start
}

export const getRefundType = (cancellationPenalties: CancellationPenalty[]) => {
  if (!cancellationPenalties || cancellationPenalties.length === 0)
    return RefundType.nonRefundable

  const cancellationDeadline = getCancellationDeadline(cancellationPenalties)
  const noPenalties = hasNoPenalties(cancellationPenalties?.[0])

  if (noPenalties || !isPast(parseISO(cancellationDeadline)))
    return RefundType.freeCancellation
  if (!noPenalties && isPast(parseISO(cancellationDeadline)))
    return RefundType.partialRefund
  return RefundType.nonRefundable
}

export const getDateTimeAndTimezone = (date: string) => {
  const splittedDate: readonly string[] = date.split('T')
  const time = splittedDate[1]
  const isZuluTime = time.slice(-1).toLowerCase() === 'z'

  if (isZuluTime) {
    const zuluTimeZone = time.slice(-1)
    return {
      date: date.replace(zuluTimeZone, ''),
      timeZone: '00:00'
    }
  }

  // the last 5 chars are the timezone
  const timeZone = time.slice(-6)
  // the timezone could be separated by '+' or '-'
  const timezoneSeparator = timeZone[0]
  if (['+', '-'].includes(timezoneSeparator)) {
    return {
      date: date.replace(timeZone, ''),
      timeZone
    }
  }

  return {
    date,
    timeZone: undefined
  }
}
